import { render } from "./PropertiesChargeStatusRadio.vue?vue&type=template&id=2bbf042f&scoped=true"
import script from "./PropertiesChargeStatusRadio.vue?vue&type=script&lang=js"
export * from "./PropertiesChargeStatusRadio.vue?vue&type=script&lang=js"

import "./PropertiesChargeStatusRadio.vue?vue&type=style&index=0&id=2bbf042f&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbf042f"]])

export default __exports__